import styled from "styled-components";

export const ReviewWrapper = styled.div`
  background-color: #eef4fd;
`;
